import React from "react";
import { Chip } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const StatusChip = ({ requestedAt }) => {
  const calculateDaysOpen = (dateStr) => {
    if (!dateStr) return null;

    const start = new Date(dateStr);
    const now = new Date();
    const diffTime = now - start;

    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const days = calculateDaysOpen(requestedAt);

  if (days === null) {
    return (
      <Chip
        label="Open"
        size="small"
        sx={{
          fontWeight: 700,
          borderRadius: "999px",
        }}
      />
    );
  }

  const getColor = () => {
    if (days <= 3) return "#2e7d32";   // green
    if (days <= 7) return "#ed6c02";   // orange
    return "#d32f2f";                  // red
  };

  const color = getColor();

  return (
    <Chip
      icon={<AccessTimeIcon sx={{ color: "white !important", fontSize: 18 }} />}
      label={`Open ${days} day${days !== 1 ? "s" : ""}`}
      size="small"
      sx={{
        backgroundColor: color,
        color: "#fff",
        fontWeight: 700,
        borderRadius: "999px",
        height: 30,
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      }}
    />
  );
};

export default StatusChip;